/**
 * Created by eliranm on 23/12/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var ContentImportErrorsModel = require('content-models/ContentImportErrorsModel');

    var ContentImportErrorsComparators = [];
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsComparators = [
            {
                name: ContentImportErrorsModel.KEYS.rowIndex,
                func: function (model) {
                    return model.getRowIndex();
                }
            }
        ];
    });

    return ContentImportErrorsComparators;
});